export { FAQAccordion, type FAQAccordionProps } from "./FAQAccordion";
